import React from "react";

const scrollToSection = (
  event: React.MouseEvent<HTMLAnchorElement>,
  href: string,
) => {
  const target = document.querySelector<HTMLElement>(href);

  if (!target) return;

  event.preventDefault();

  const toc = document.querySelector<HTMLElement>("#faq .toc");
  const tocTop = toc ? parseFloat(window.getComputedStyle(toc).top) || 0 : 0;
  const offset = (toc?.offsetHeight || 0) + tocTop + 16;
  const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  window.history.pushState(null, "", href);
  window.scrollTo({
    top: Math.max(targetTop - offset, 0),
    behavior: prefersReducedMotion ? "auto" : "smooth",
  });
};

const TableOfContents = () => (
  <nav className="toc" aria-label="Jump to a section">
    <div className="container toc-inner">
      <span className="toc-label">Jump to:</span>
      <div className="toc-pills">
        <a
          href="#getting-started"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#getting-started")}
        >
          Getting started
        </a>
        <a
          href="#how-it-works"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#how-it-works")}
        >
          How it works
        </a>
        <a
          href="#money"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#money")}
        >
          Pricing
        </a>
        <a
          href="#taking-a-course"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#taking-a-course")}
        >
          Taking a course
        </a>
        <a
          href="#tech"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#tech")}
        >
          Tech &amp; access
        </a>
        <a
          href="#about-us"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#about-us")}
        >
          About 42courses
        </a>
        <a
          href="#teams"
          className="toc-pill"
          onClick={(event) => scrollToSection(event, "#teams")}
        >
          For teams
        </a>
      </div>
    </div>
  </nav>
);

export default TableOfContents;
